import { render, staticRenderFns } from "./ProfileMonitoringDashboard.vue?vue&type=template&id=3a77f3fe"
import script from "./ProfileMonitoringDashboard.vue?vue&type=script&lang=js"
export * from "./ProfileMonitoringDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports